/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { defaultErrorResponse } from "../RequestUtil";
import { parseGuestAccountList } from "../data/Util";

export const parseLoginResponse = ({response}) => {
  const verifyExpiration = response.expiration;
  if (verifyExpiration == null) {
    return defaultErrorResponse;
  }

  return {
    login: {
      verifyPending: true,
      verifyExpiration: verifyExpiration,
    },
  };
};

export const parseLoginVerifyResponse = ({response}) => {
  const { token, guest_accounts } = response;
  if (token == null || guest_accounts == null) {
    return defaultErrorResponse;
  }

  return {
    account: {
      loggedIn: true,
      accountList: parseGuestAccountList(guest_accounts),
    },
    login: {
      verifyPending: false,
      verifyExpiration: null,
    },
    request: {
      token: token,
    },
  };
};
